import { createFileRoute } from "@tanstack/react-router";
import TrapPage from "@/pages/TrapPage";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/trap-dealer-list/")({
  head: () => routeHead("/trap-dealer-list/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <TrapPage />
  );
}
